var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7422 0.628906H5.74219C2.98119 0.628906 0.742188 2.86791 0.742188 5.62891V19.6289C0.742188 22.3899 2.98119 24.6289 5.74219 24.6289H19.7422C22.5042 24.6289 24.7422 22.3899 24.7422 19.6289V5.62891C24.7422 2.86791 22.5042 0.628906 19.7422 0.628906ZM8.74219 19.6289H5.74219V8.62891H8.74219V19.6289ZM7.24219 7.36091C6.27619 7.36091 5.49219 6.57091 5.49219 5.59691C5.49219 4.62291 6.27619 3.83291 7.24219 3.83291C8.20819 3.83291 8.99219 4.62291 8.99219 5.59691C8.99219 6.57091 8.20919 7.36091 7.24219 7.36091ZM20.7422 19.6289H17.7422V14.0249C17.7422 10.6569 13.7422 10.9119 13.7422 14.0249V19.6289H10.7422V8.62891H13.7422V10.3939C15.1382 7.80791 20.7422 7.61691 20.7422 12.8699V19.6289Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.cb219890f5fc67037c351df9a5265e7b.svg";
export { ForwardRef as ReactComponent };